import { render, staticRenderFns } from "./EmailUs.vue?vue&type=template&id=09cca67d&scoped=true"
import script from "./EmailUs.vue?vue&type=script&lang=ts"
export * from "./EmailUs.vue?vue&type=script&lang=ts"
import style0 from "./EmailUs.vue?vue&type=style&index=0&id=09cca67d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cca67d",
  null
  
)

export default component.exports